const state = {
  currentInvoice: null
}

const mutations = {
  set_current_invoice(state, payload) {
    state.currentInvoice = payload
  }
}

const actions = {
  setCurrentInvoice({ commit }, payload) {
    commit('set_current_invoice', payload)
  }
}

const getters = {
  currentInvoice: state => state.currentInvoice || {}
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
